import { ChartLine, Shield } from "lucide-react";
import pceImg from '../images/ai-tools/patent-cost-estimate.png';
import ipassImg from '../images/ai-tools/ip-asset-assessment-tool.png';
import patentRoiImg from '../images/ai-tools/patent-roi-calculator.png';
import tmroiImg from '../images/ai-tools/trademark-roi-calculator.png';
import statupIpImg from '../images/ai-tools/startup-ip-valuation.png';

export const toolsData = [
  {
    id: "ip-asset-assessment",
    title: "IP Asset Assessment Tool",
    description: "",
    icon: Shield,
    features: [
      {
        title: "Portfolio Evaluation",
        description: "Conducts a detailed analysis of your startup’s IP assets to identify strengths and gaps."
      },
      {
        title: "Market & Competitor Insights",
        description: "Reviews the competitive landscape to benchmark innovations against industry players."
      },
      {
        title: "Actionable Strategy",
        description: "Provides a tailored roadmap with recommendations for strengthening and protecting IP."
      }
    ],
    buttonUrl: "/ai-tools/ip-asset-assessment", //https://claude.ai/share/6351a2bb-9404-44c6-81df-5871f76c0a6f
    image: ipassImg,
    imageAlt: "Intellectual property concepts and patent documentation",
    reverseLayout: true
  },
  {
    id: "patent-roi-calculator",
    title: "Patent ROI Calculator",
    description: "",
    icon: ChartLine,
    features: [
      {
        title: "ROI Analysis",
        description: "Evaluates both basic and advanced return on investment for trademark applications and registrations"
      },
      {
        title: "Portfolio Optimization",
        description: "Assesses synergy across trademark holdings to maximize strategic impact."
      },
      {
        title: "Brand Value Insights",
        description: "Estimates the contribution of trademarks to overall brand equity and business growth."
      }
    ],
    buttonUrl: "/ai-tools/patent-roi-calculator",
    image: patentRoiImg,
    imageAlt: "Startup innovation tools and technology workspace",
    reverseLayout: false
  },
  {
    id: "trademark-roi-calculator",
    title: "Trademark ROI Calculator",
    description: "",
    icon: Shield,
    features: [
      {
        title: "ROI Analysis",
        description: "Evaluates both basic and advanced return on investment for trademark applications and registrations"
      },
      {
        title: "Portfolio Optimization",
        description: "Assesses synergy across trademark holdings to maximize strategic impact."
      },
      {
        title: "Brand Value Insights",
        description: "Estimates the contribution of trademarks to overall brand equity and business growth."
      }
    ],
    buttonUrl: "/ai-tools/trademark-roi-calculator",
    image: tmroiImg,
    imageAlt: "Intellectual property concepts and patent documentation",
    reverseLayout: true
  },
  // {
  //   id: "patent-office-action-response",
  //   title: "Patent Office Action Response Tool",
  //   description: "",
  //   icon: Shield,
  //   features: [
  //     {
  //       title: "AI-Powered Analysis",
  //       description: "Reviews USPTO Office Actions, identifying examiner rejections and key issues"
  //     },
  //     {
  //       title: "Automated Drafting",
  //       description: "Generates tailored response drafts with suggested arguments, citations, and claim amendments."
  //     },
  //     {
  //       title: "Efficiency & Accuracy",
  //       description: "Reduces attorney workload, shortens response time, and improves compliance with USPTO requirements."
  //     }
  //   ],
  //   buttonUrl: "/ai-tools/patent-office-action-response",
  //   image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&h=600",
  //   imageAlt: "Intellectual property concepts and patent documentation",
  //   reverseLayout: false
  // },
  // {
  //   id: "trademark-rejection-response",
  //   title: "Trademark Rejection Response Assistant",
  //   description: "",
  //   icon: Shield,
  //   features: [
  //     {
  //       title: "Office Action Analysis",
  //       description: "Reviews USPTO trademark refusals and identifies examiner concerns"
  //     },
  //     {
  //       title: "Drafted Response Guidance",
  //       description: "Suggests tailored arguments, evidence, and response language to overcome rejections."
  //     },
  //     {
  //       title: "Faster Resolution",
  //       description: "Streamlines the reply process to improve approval chances and reduce attorney workload."
  //     }
  //   ],
  //   buttonUrl: "/ai-tools/trademark-rejection-response",
  //   image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&h=600",
  //   imageAlt: "Intellectual property concepts and patent documentation",
  //   reverseLayout: true
  // },
  {
    id: "founder-ip-startup-valuation",
    title: "Founder IP & Startup Valuation Tool",
    description: "",
    icon: Shield,
    features: [
      {
        title: "Intelligent IP Discovery",
        description: "Identifies and catalogs a startup’s key intellectual property assets."
      },
      {
        title: "Risk & Gap Assessment",
        description: "Analyzes protection gaps to highlight areas needing stronger IP coverage."
      },
      {
        title: "Valuation Insights",
        description: "Provides a preliminary estimate of both IP portfolio worth and overall startup valuation."
      }
    ],
    buttonUrl: "/ai-tools/startup-ip-valuation",
    image: statupIpImg,
    imageAlt: "Intellectual property concepts and patent documentation",
    reverseLayout: false
  },
  {
    id: "patent-cost-calculator",
    title: "Patent Cost Estimate Calculator",
    description: "",
    icon: ChartLine,
    features: [
      {
        title: "Accurate Cost Forecasting",
        description: "Provides detailed patent cost estimates using industry data."
      },
      {
        title: "AI-Driven IP Insights",
        description: "Identifies potential IP assets and uncovers protection gaps."
      },
      {
        title: "Early Value Assessment",
        description: "Delivers preliminary valuation estimates to guide filing strategy and budgeting decisions."
      }
    ],
    buttonUrl: "/ai-tools/patent-cost-estimate", //https://claude.ai/share/6f772234-f909-4024-a3d6-fcfcda29fb28
    image: pceImg,
    imageAlt: "Startup innovation tools and technology workspace",
    reverseLayout: false
  },
  // {
  //   id: "provisional-patent-chatbot",
  //   title: "Provisional Patent Application Chatbot",
  //   description: "",
  //   icon: Shield,
  //   features: [
  //     {
  //       title: "Step-by-Step Guidance",
  //       description: "Walks inventors through drafting a provisional patent application in plain language."
  //     },
  //     {
  //       title: "AI-Powered Drafting",
  //       description: "Helps structure claims, descriptions, and drawings for USPTO submission."
  //     },
  //     {
  //       title: "Filing Readiness",
  //       description: "Ensures applications meet basic requirements, reducing errors and preparation time."
  //     }
  //   ],
  //   buttonUrl: "/ai-tools/provisional-patent-chatbot",
  //   image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&h=600",
  //   imageAlt: "Intellectual property concepts and patent documentation",
  //   reverseLayout: true
  // }
];
